import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
    const handleNavClick = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };

    return (
        <>
            {/* Footer Start */}
            <div className="container-fluid bg-dark footer py-4">
                <div className="container">
                    <div className="row g-4">

                        {/* Nossa Loja */}
                        <div className="col-lg-4 col-md-6">
                            <h5 className="text-uppercase text-light mb-3">
                                Nossa Loja
                            </h5>

                            <p className="mb-2">
                                <i className="fa fa-map-marker-alt text-primary me-3"></i>
                                Rua Maringá, 2200, Ivaté - PR
                            </p>

                            <p className="mb-2">
                                <i className="fa fa-phone-alt text-primary me-3"></i>
                                44 9 98827-3599
                            </p>

                            <p className="mb-2">
                                <i className="fa fa-envelope text-primary me-3"></i>
                                mafratintas01@gmail.com
                            </p>

                            <div className="d-flex pt-2">
                                <a
                                    className="btn btn-square btn-light"
                                    href="https://www.instagram.com/tintasmafraivate/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <i className="fab fa-instagram"></i>
                                </a>
                            </div>
                        </div>

                        {/* Links */}
                        <div className="col-lg-4 col-md-6">
                            <h5 className="text-uppercase text-light mb-3">
                                Links rápidos
                            </h5>

                            <Link
                                to="/about"
                                className="btn btn-link d-block text-start"
                                onClick={handleNavClick}
                            >
                                Sobre
                            </Link>

                            <Link
                                to="/contact"
                                className="btn btn-link d-block text-start"
                                onClick={handleNavClick}
                            >
                                Contato
                            </Link>
                        </div>

                        {/* Horários */}
                        <div className="col-lg-4 col-md-6">
                            <h5 className="text-uppercase text-light mb-3">
                                Horário de Funcionamento
                            </h5>

                            <p className="text-uppercase mb-0">
                                Segunda a Sexta
                            </p>
                            <p className="mb-2">
                                08:00 - 18:00
                            </p>

                            <p className="text-uppercase mb-0">
                                Sábado
                            </p>
                            <p className="mb-2">
                                08:00 - 13:00
                            </p>

                            <p className="text-uppercase mb-0">
                                Domingo
                            </p>
                            <p className="mb-0">
                                Fechado
                            </p>
                        </div>

                    </div>
                </div>
            </div>

            {/* Copyright */}
            <div className="container-fluid text-body copyright py-2">
                <div className="container">
                    <div className="text-center">
                        &copy;{" "}
                        <Link
                            to="/"
                            className="fw-semi-bold text-decoration-none"
                            onClick={handleNavClick}
                        >
                            Mafra Tintas
                        </Link>
                        , All Right Reserved.
                    </div>
                </div>
            </div>
        </>
    );
};

export default Footer;